import { Col, ControlLabel, FormGroup, Row } from "react-bootstrap";

import Cleave from "cleave.js/react";
import CurrencySelect from "../Currency/CurrencySelect";
import EnumSelect from "../../elements/CustomSelect/EnumSelect";
import { FormattedMessage } from "react-intl";
import React from "react";

const SupplierFormPayment = ({
  updateFormValue,
  defaultTermDelaisPaiement,
  defaultTermNetsFinDeMois,
  currency,
  iban,
  swift
}) => {
  return (
    <div>
      <Row>
        <Col xs={12}>
          <h4>
            <FormattedMessage
              id="ids_payment"
              description="collaborator payment input field label"
              defaultMessage="Paiement"
            />
          </h4>
        </Col>
        <Col xs={10} sm={6}>
          <FormGroup>
            <ControlLabel>
              <FormattedMessage id="ids_payment_deadline" />
            </ControlLabel>
            <div className="space-between">
              <div className="width-percent-48">
                <EnumSelect
                  enumName="TermDelaisDePaiementEnum"
                  value={defaultTermDelaisPaiement}
                  onSelected={e =>
                    updateFormValue("defaultTermDelaisPaiement", e)
                  }
                />
              </div>
              <div className="width-percent-48">
                <EnumSelect
                  enumName="TermNetsFinDeMoisEnum"
                  value={defaultTermNetsFinDeMois}
                  onSelected={e =>
                    updateFormValue("defaultTermNetsFinDeMois", e)
                  }
                />
              </div>
            </div>
          </FormGroup>
        </Col>
        <Col xs={2} sm={2}>
          <FormGroup>
            <ControlLabel>
              <FormattedMessage
                id="ids_currency"
                description="client currency input field label"
                defaultMessage="Devise"
              />
            </ControlLabel>
            <CurrencySelect
              value={currency}
              onSelected={e => updateFormValue("currency", e)}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col xs={7} sm={6}>
          <FormGroup>
            <ControlLabel>
              <FormattedMessage id="ids_iban" />
            </ControlLabel>
            <Cleave
              className="form-control"
              placeholder="FR33 2002 0202 2606 0002 4M02 606"
              name="iban"
              style={{ textTransform: "uppercase" }}
              options={{
                blocks: [4, 4, 4, 4, 4, 4, 4, 4, 4, 4],
                delimiter: " "
              }}                  
              value={iban}
              onChange={e => updateFormValue("iban", e.target)}
            />
          </FormGroup>
        </Col>
        <Col xs={5} sm={3}>
          <FormGroup>
            <ControlLabel>
              <FormattedMessage id="ids_swift" />
            </ControlLabel>
            <Cleave
              className="form-control"
              placeholder="AAA FR 00 000"
              name="swift"
              style={{ textTransform: "uppercase" }}
              // options={{ blocks: [3,2,2,3], delimiter: ' ' }}
              value={swift}
              onChange={e => updateFormValue("swift", e.target)}
            />
          </FormGroup>
        </Col>
      </Row>
    </div>
  );
};

export default SupplierFormPayment;
